import type { YorumPuanFiltresi } from "@/api/yorumlar";
import { SegmentedTabs } from "@/components/ui";
import { t } from "@/i18n";

const SECENEKLER: YorumPuanFiltresi[] = ["hepsi", 5, 4, 3, 2, 1];

interface YildizFiltreProps {
  value: YorumPuanFiltresi;
  onChange: (value: YorumPuanFiltresi) => void;
}

function label(v: YorumPuanFiltresi): string {
  return v === "hepsi" ? t("yorumlar.filtre.hepsi") : `${v} ★`;
}

/** Yildiz filtresi (1-5 + tumu) — sozlesme §2. */
export function YildizFiltre({ value, onChange }: YildizFiltreProps) {
  return (
    <SegmentedTabs
      value={value}
      onChange={onChange}
      ariaLabel={t("yorumlar.filtre.aria")}
      options={SECENEKLER.map((secim) => ({ value: secim, label: label(secim) }))}
    />
  );
}
